export default __webpack_public_path__ + "static/media/08_DAIF_WHY_DELL_04_03.a2788612.mp4";